import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '@auth/store/auth.reducers';

export const REDUCER_AUTH_ID = 'auth';

export const selectAuth = createFeatureSelector<AuthState>(REDUCER_AUTH_ID);

export const selectCurrentUser = createSelector(selectAuth, (auth) => auth.user);
export const selectRolesEntities = createSelector(selectAuth, (auth) => auth.roles);
